import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from '@/shared/layout';
import { useConstructionQaInspections } from './hooks/useConstructionQaInspections';
import { useCompany } from '@/modules/company/hooks/useCompany';
import { QaKPIBoard } from './components/QaKPIBoard';
import { QaToolbar } from './components/QaToolbar';
import { QaTable } from './components/QaTable';
import { AuthButton } from '@/core/permissions/AuthButton';

export default function QaListPage() {
  const navigate = useNavigate();
  const { company } = useCompany();
  const { 
    inspections, 
    isLoading, 
    stats, 
    filters, 
    setFilters 
  } = useConstructionQaInspections(company?.id || '');

  return (
    <PageLayout
      title="Kiểm soát chất lượng (QA/QC)"
      description="Quản lý phiếu kiểm tra, nghiệm thu kỹ thuật và báo cáo không phù hợp (NCR)"
      breadcrumbs={[{ label: 'Thi công' }, { label: 'Chất lượng' }]}
      actions={
        <div className="flex gap-2">
          <Button variant="outline" icon="ri-download-line">Báo cáo tổng hợp</Button>
          <AuthButton module="construction" action="create" variant="primary" icon="ri-add-line" onClick={() => navigate('/construction/qa/create')}>
            Tạo phiếu kiểm tra
          </AuthButton>
        </div>
      }
    >
      <QaKPIBoard stats={stats} isLoading={isLoading} />
      
      <QaToolbar 
        filters={filters} 
        onFilterChange={setFilters} 
        onAdd={() => navigate('/construction/qa/create')}
      />

      <QaTable 
        data={inspections} 
        isLoading={isLoading} 
        onViewDetail={(id) => navigate(`/construction/qa/detail/${id}`)}
      />
    </PageLayout>
  );
}

import { Button } from '@/components/ui';
